import {
    useFloating,
    useDismiss,
    useRole,
    useClick,
    useInteractions,
    FloatingFocusManager,
    FloatingOverlay,
    FloatingPortal,
} from "@floating-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icons } from "assets/icons";

export const ConfirmOperationModal = (props) => {
    const { headerText, paragraphText, okButtonText } = props;

    const { refs, context } = useFloating({
        open: props.isOpen,
        onOpenChange: props.setModalOpen, // The OK button callback handler
    });
    const click = useClick(context);
    const role = useRole(context);
    const dismiss = useDismiss(context, { outsidePressEvent: "mousedown" });
    const { getFloatingProps } = useInteractions([click, role, dismiss]);

    return (
        <>
            <FloatingPortal>
                {props.isOpen && (
                    <FloatingOverlay className='modal-overlay' lockScroll>
                        <FloatingFocusManager context={context}>
                            <div className='modal' ref={refs.setFloating} {...getFloatingProps()}>
                                <div className='close-btn-wrapper'>
                                    <button onClick={() => props.setModalOpen(false)} className='modal-close'>
                                        <FontAwesomeIcon icon={icons.solid.faXmark} />
                                    </button>
                                </div>
                                <h2>{headerText}</h2>

                                <p>{paragraphText}</p>
                                <div className='button-wrapper'>
                                    <button className='btn deleteBtn' onClick={() => props.setModalOpen(true)}>
                                        {okButtonText}
                                    </button>
                                    <button className='btn outline' onClick={() => props.setModalOpen(false)}>
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </FloatingFocusManager>
                    </FloatingOverlay>
                )}
            </FloatingPortal>
        </>
    );
};
